import { defineMessage } from 'react-intl';

export const labelCommonI18n = {
  about: defineMessage({
    id: 'common:label.about',
    defaultMessage: 'About'
  }),
  academicLevel: defineMessage({
    id: 'common:label.academic-level',
    defaultMessage: 'Academic level'
  }),
  address: defineMessage({
    id: 'common:label.address',
    defaultMessage: 'Address'
  }),
  ageRange: defineMessage({
    id: 'common:label.age-range',
    defaultMessage: 'Age range'
  }),
  birthday: defineMessage({
    id: 'common:label.birthday',
    defaultMessage: 'Birthday'
  }),
  bookings: defineMessage({
    id: 'common:label.bookings',
    defaultMessage: 'Bookings'
  }),
  bookingNo: defineMessage({
    id: 'common:label.booking-no',
    defaultMessage: 'Booking No.'
  }),
  businessNameInLang: defineMessage({
    id: 'common:label.business-name-in-lang',
    defaultMessage: 'Business Name ({lang})'
  }),
  category: defineMessage({
    id: 'common:label.category',
    defaultMessage: 'Category'
  }),
  class: defineMessage({
    id: 'common:label.class',
    defaultMessage: 'Class'
  }),
  classTitle: defineMessage({
    id: 'common:label.class-title',
    defaultMessage: 'Class title'
  }),
  countryOrRegion: defineMessage({
    id: 'common:label.country-or-region',
    defaultMessage: 'Country/Region'
  }),
  currencyAmount: defineMessage({
    id: 'common:label.currency-amount',
    defaultMessage: 'Amount'
  }),
  curriculum: defineMessage({
    id: 'common:label.curriculum',
    defaultMessage: 'Curriculum'
  }),
  customer: defineMessage({
    id: 'common:label.customer',
    defaultMessage: 'Customer'
  }),
  date: defineMessage({
    id: 'common:label.date',
    defaultMessage: 'Date'
  }),
  dateAndTime: defineMessage({
    id: 'common:label.date-time',
    defaultMessage: 'Date and time'
  }),
  dateOfBirth: defineMessage({
    id: 'common:label.dob',
    defaultMessage: 'Date of birth'
  }),
  default: defineMessage({
    id: 'common:label.default',
    defaultMessage: 'Default'
  }),
  deliveryLanguage: defineMessage({
    id: 'common:label.delivery-language',
    defaultMessage: 'Delivery language'
  }),
  description: defineMessage({
    id: 'common:label.description',
    defaultMessage: 'Description'
  }),
  details: defineMessage({
    id: 'common:label.details',
    defaultMessage: 'Details'
  }),
  difficulty: defineMessage({
    id: 'common:label.difficulty',
    defaultMessage: 'Difficulty'
  }),
  email: defineMessage({
    id: 'common:label.email',
    defaultMessage: 'Email address'
  }),
  endDate: defineMessage({
    id: 'common:label.end-date',
    defaultMessage: 'End date'
  }),
  endTime: defineMessage({
    id: 'common:label.end-time',
    defaultMessage: 'End time'
  }),
  filters: defineMessage({
    id: 'common:label.filters',
    defaultMessage: 'Filters'
  }),
  fullName: defineMessage({
    id: 'common:label.full-name',
    defaultMessage: 'Full name'
  }),
  gender: defineMessage({
    id: 'common:label.gender',
    defaultMessage: 'Gender'
  }),
  instructor: defineMessage({
    id: 'common:label.instructor',
    defaultMessage: 'Instructor'
  }),
  location: defineMessage({
    id: 'common:label.location',
    defaultMessage: 'Location'
  }),
  optional: defineMessage({
    id: 'common:label.optional',
    defaultMessage: 'Optional'
  }),
  orderNo: defineMessage({
    id: 'common:label.order-no',
    defaultMessage: 'Order No.'
  }),
  password: defineMessage({
    id: 'common:label.password',
    defaultMessage: 'Password'
  }),
  passwordCurrent: defineMessage({
    id: 'common:label.current-password',
    defaultMessage: 'Current password'
  }),
  passwordRepeat: defineMessage({
    id: 'common:label.repeat-password',
    defaultMessage: 'Repeat password'
  }),
  paymentDetails: defineMessage({
    id: 'common:label.payment-details',
    defaultMessage: 'Payment details'
  }),
  paymentMethod: defineMessage({
    id: 'common:label.payment-method',
    defaultMessage: 'Payment method'
  }),
  personsNameInLang: defineMessage({
    id: 'common:label.persons-name-in-lang',
    defaultMessage: '{lang} name'
  }),
  phoneNumber: defineMessage({
    id: 'common:label.phone-number',
    defaultMessage: 'Phone number'
  }),
  price: defineMessage({
    id: 'common:label.price',
    defaultMessage: 'Price'
  }),
  refundMethod: defineMessage({
    id: 'common:label.refund-method',
    defaultMessage: 'Refund method'
  }),
  responseFromName: defineMessage({
    id: 'common:label.response-from-name',
    defaultMessage: 'Response from {name}'
  }),
  role: defineMessage({
    id: 'common:label.user-role',
    defaultMessage: 'Role'
  }),
  room: defineMessage({
    id: 'common:label.room',
    defaultMessage: 'Room'
  }),
  roomName: defineMessage({
    id: 'common:label.room-name',
    defaultMessage: 'Room name'
  }),
  schedule: defineMessage({
    id: 'common:label.schedule',
    defaultMessage: 'Schedule'
  }),
  startDate: defineMessage({
    id: 'common:label.start-date',
    defaultMessage: 'Start date'
  }),
  startTime: defineMessage({
    id: 'common:label.start-time',
    defaultMessage: 'Start time'
  }),
  topics: defineMessage({
    id: 'common:label.topics',
    defaultMessage: 'Topics'
  }),
  time: defineMessage({
    id: 'common:label.time',
    defaultMessage: 'Time'
  }),
  venue: defineMessage({
    id: 'common:label.venue',
    defaultMessage: 'Venue'
  }),
  verified: defineMessage({
    id: 'common:label.verified',
    defaultMessage: 'Verified'
  })
};
